import { typography } from "../common/fonts";
import { colors as darkColors } from "./dark/palette";
import { colors as lightColors } from "./light/palette";
import { THEME, CrmTheme } from "../types";

export const darkTheme: CrmTheme = {
  key: THEME.dark,
  typography,
  colors: darkColors,
};

export const lightTheme: CrmTheme = {
  key: THEME.light,
  typography,
  colors: lightColors,
};

export { default as DarkGlobalStyles } from "./dark/globalStyles";
export { default as LightGlobalStyles } from "./light/globalStyles";
